import React from 'react';
import FAQItem from './FAQItem.jsx';
import style from './style.scss';

class FAQ extends React.Component {
  constructor(props, context) {
    super(props, context);

  }

  render() {
    return (
      <section className="center">
        <div className='faq-container'>
          <form className='faq-search-form'>
            <h2 className='faq-search-form-title'>Các câu hỏi thường gặp</h2>
          </form>
          {/* <form className='faq-search-form'>
            <h2 className='faq-search-form-title'>Tìm kiếm câu hỏi</h2>
            <div className='faq-search-input-group'>
              <input className='faq-input' placeholder='Chúng tôi có thể giúp gì cho bạn ?'/>
              <button className="faq-btn-search" type="submit"><i className="vtd-search"></i><span>Tìm kiếm</span></button>
            </div>
          </form> */}
          <div className='faq-wrap-list-item'>
            {this.props.data.map((question, i) => {
              return (<FAQItem key={i} {...question}/>)
            })
}
          </div>
        </div>
      </section>
    );
  }
}

export default FAQ;



// WEBPACK FOOTER //
// ./components/faq/FAQ.jsx